/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSendBackward: {
  name: 'send-backward';
  data: string;
} = {
  name: 'send-backward',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v13a1 1 0 1 0 2 0V4h13a1 1 0 1 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z" fill="currentColor"/></svg>`,
};
